// Source
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelClientContact from "../../model/custom/ClientContact";
import * as Instance from "../Instance";

export const createData = (
    clientId: number,
    department: string,
    firstName: string,
    lastName: string,
    firstNameKanji: string,
    lastNameKanji: string,
    firstNameKana: string,
    lastNameKana: string,
    phoneNumber: string,
    email: string,
    isRreviewer: boolean,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        client_id: clientId,
        department,
        first_name: firstName,
        last_name: lastName,
        first_name_kanji: firstNameKanji,
        last_name_kanji: lastNameKanji,
        first_name_kana: firstNameKana,
        last_name_kana: lastNameKana,
        phone_number: phoneNumber,
        email,
        is_reviewer: isRreviewer,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/client_contact/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (
    id: number,
    clientId: number,
    department: string,
    firstName: string,
    lastName: string,
    firstNameKanji: string,
    lastNameKanji: string,
    firstNameKana: string,
    lastNameKana: string,
    phoneNumber: string,
    email: string,
    isRreviewer: boolean,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        client_id: clientId,
        department,
        first_name: firstName,
        last_name: lastName,
        first_name_kanji: firstNameKanji,
        last_name_kanji: lastNameKanji,
        first_name_kana: firstNameKana,
        last_name_kana: lastNameKana,
        phone_number: phoneNumber,
        email,
        is_reviewer: isRreviewer,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/client_contact/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/client_contact/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/client_contact/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelClientContact.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        client_id: dataMain.client_id as unknown as string,
        first_name: dataMain.first_name,
        last_name: dataMain.last_name,
        email: dataMain.email,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/client_contact/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/client_contact/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
